import React from 'react';

export interface Sign98IconProps {}

export const Sign98Icon: React.FC<Sign98IconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 2C15.0899 2 18 4.91015 18 8.5V20.25H15V8.5C15 6.567 13.433 5 11.5 5C9.56704 5 8.00004 6.567 8.00004 8.5V14.6155C8.00004 14.6155 8.00004 14.25 8.00004 14.75C8.00004 15.25 8.00004 15.25 8.00004 15.75C8.00004 16.25 8.00004 16.75 8.00004 16.25V20.25H5.00004C5.00009 17.75 5 17.75 5 16.25C5 16.25 5 15.25 5.00004 14.75V14.634V8.5C5.00004 4.91015 7.91018 2 11.5 2Z"
        fill="#192033"
      />
    </svg>
  );
};
